enum SearchType {
  TITLE = 'title',
  WRITER = 'writer',
  SIGNER = 'signer',
}

export default SearchType;
